import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Header from '../header/Header';
import { clearPersister } from '../../utils/common';

import { useToken } from '../../store/slices/authSlice';
import Footer from '../footer/Footer';

const AuditorLayout = () => {
  const dispatch = useDispatch();

  const token = useToken();

  useEffect(() => {
    const token = localStorage.getItem('callex-token');
    if (!token) {
      clearPersister(dispatch);
    }
  }, []);

  if (!token) {
    return <Navigate to="/auditor_login" replace />;
  }

  return (
    <>
      <Header />
      <div className="admin-outlet-container">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default AuditorLayout;
